var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPalette = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm2 2.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM7 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm2 .5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5.417 2.264A6.75 6.75 0 0 1 14.75 8.5a.75.75 0 0 1-.75.75h-1.3a5.748 5.748 0 0 1-5.7 5A5.75 5.75 0 0 1 1.25 8.5a6.75 6.75 0 0 1 4.167-6.236zM11.25 8.5a.75.75 0 0 1 .75-.75h1.196a5.255 5.255 0 0 0-3.187-4.1A5.25 5.25 0 0 0 2.75 8.5a4.25 4.25 0 1 0 8.5 0z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPalette);
export default ForwardRef;